(function() {
  function injectJapanese() {
    document.querySelectorAll('.language-selector .disclosure__list').forEach(function(list) {
      if (list.querySelector('[data-value="ja"]')) return;
      var li = document.createElement('li');
      li.className = 'disclosure__item';
      li.setAttribute('tabindex', '-1');
      li.innerHTML = '<a class="link link--text disclosure__link caption-large focus-inset" href="#" hreflang="ja" lang="ja" data-value="ja"><span class="visibility-hidden"></span><span>\u65e5\u672c\u8a9e</span></a>';
      list.appendChild(li);
      // bind click to the parent localization-form
      var form = list.closest('localization-form');
      if (form) {
        li.querySelector('a').addEventListener('click', function(e) {
          e.preventDefault();
          var input = form.querySelector('input[name="locale_code"]');
          var f = form.querySelector('form');
          if (input) input.value = 'ja';
          if (f) f.submit();
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectJapanese);
  } else {
    injectJapanese();
  }
})();